import { ApplyLink, Arrow } from './ui'
import { useViewportVideo } from './useViewportVideo'
import VideoSoundControl from './VideoSoundControl'
import VideoPoster from './VideoPoster'
import './gae-invitation.css'

export default function GaeInvitation() {
  const { error, videoProps, previewProps, controlsProps } = useViewportVideo('/images/gae-invitation-poster.jpg')

  return <section className="gae-invitation section-pad" id="gae-invitation" aria-labelledby="gae-invitation-title">
    <div className="gae-invitation-inner">
      <div className="gae-invitation-heading">
        <p className="gae-invitation-eyebrow"><span aria-hidden="true" />AN INVITATION TO GROW</p>
        <span className="gae-invitation-label">พี่เกลชวนคุณ</span>
        <h2 id="gae-invitation-title">ให้การดูแลตัวเอง<br /><em>เป็นจุดเริ่มต้น<br className="gae-title-break" />ของบทใหม่</em></h2>
      </div>

      <figure className="gae-film" aria-labelledby="gae-film-title">
        <div className="gae-film-frame">
          <video {...videoProps} width="720" height="1280" aria-label="วิดีโอพี่เกลชวนร่วม EMPRESS OF WELLNESS 2026">
            <source src="/videos/gae-invitation.mp4" type="video/mp4" />
            เบราว์เซอร์นี้ไม่รองรับวิดีโอ <a href="/videos/gae-invitation.mp4">เปิดคลิปพี่เกล</a>
          </video>
          <VideoPoster {...previewProps} />
        </div>
        <VideoSoundControl {...controlsProps} />
        <figcaption><div><span>EMPRESS OF WELLNESS 2026</span><strong id="gae-film-title">คำชวนจากพี่เกล <small>01:37</small></strong></div><a href="/videos/gae-invitation.mp4" target="_blank" rel="noopener noreferrer" aria-label="เปิดคลิปพี่เกลในแท็บใหม่"><Arrow /></a></figcaption>
        {error && <p className="gae-film-error" role="alert">ยังไม่สามารถเล่นวิดีโอได้ ลองกดเล่นอีกครั้ง หรือ <a href="/videos/gae-invitation.mp4" target="_blank" rel="noopener noreferrer">เปิดวิดีโอโดยตรง</a></p>}
      </figure>

      <div className="gae-invitation-copy">
        <p>ฟังคำชวนจากพี่เกลถึงผู้หญิงวัย 35+<br />มาร่วม EMPRESS OF WELLNESS 2026<br />และเริ่มต้นการเติบโตในแบบของคุณ</p>
        <div className="gae-invitation-note"><span>FOR WOMEN <strong>35+</strong></span><p>สุขภาพ ความมั่นใจ<br />และคุณค่าในตัวคุณ</p></div>
        <div className="gae-invitation-actions"><ApplyLink location="gae-invitation" /><a className="text-link" href="#competition">รู้จักการแข่งขันทั้ง 3 รอบ <Arrow /></a></div>
      </div>
    </div>
  </section>
}
